import { useEffect, useState } from 'react'

import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { useWorkspaces } from 'hooks/useWorkspaces'
import { useQueryParams } from 'hooks/useQueryParams'

export const useShowVirtualMarketerUpgradeCta = () => {
  const [showCta, setShowCta] = useState(false)
  const workspaces = useWorkspaces()
  const isVirtualMarketerUpgradeEnabled =
    useFlipperFlag('virtual_marketer_upgrade') || workspaces.some((w) => w.show_virtual_marketer_upgrade)
  const { show_autopilot_upgrade: showAutopilotUpgrade } = useQueryParams()

  useEffect(() => {
    if ((isVirtualMarketerUpgradeEnabled || showAutopilotUpgrade) && workspaces.length > 0) {
      // We can show the CTA if they haven't already upgraded in any workspace
      const canShowToWorkspace = workspaces.filter((w) => w.is_virtual_marketer).length === 0

      if (canShowToWorkspace) {
        setShowCta(true)
      }
    }
  }, [isVirtualMarketerUpgradeEnabled, workspaces, showAutopilotUpgrade])

  return { showCta }
}
